module.exports = __webpack_public_path__ + "static/media/aviso-feriado-carnaval-2023.08e4a3f2.png";